import { render } from "./exhibitionList.vue?vue&type=template&id=0b2647ba"
import script from "./exhibitionList.vue?vue&type=script&lang=js"
export * from "./exhibitionList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibition/exhibitionList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b2647ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b2647ba', __exports__)) {
    console.log('reload')
    api.reload('0b2647ba', __exports__)
  }
  
  module.hot.accept("./exhibitionList.vue?vue&type=template&id=0b2647ba", () => {
    console.log('re-render')
    api.rerender('0b2647ba', render)
  })

}


export default __exports__